module.exports = __webpack_public_path__ + "img/gapplogo.aae74720.png";